import _isObject from 'lodash/isObject'
import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

import Sel from './styles-consts'
import Icons from '@/shared/AppIcons'

import { GradeRowDetailScope, type GradeReacao } from '../analise-reacoes.scope'

const styles = {
    self: {
        columnGap: 'var(--spacing-scale-2x)'        
    },
    mb0: {marginBottom: 0}
} satisfies Record<string, React.CSSProperties>

export type GradeRowDetailProps = {
    scope: GradeRowDetailScope
}

class GradeRowDetailViewClass implements FCClassContext<GradeRowDetailProps> {
    scope!: GradeRowDetailScope

    render({ scope }: GradeRowDetailProps) {
        this.scope = scope

        return (
            <div className={clsx(Sel.row, Sel.noGridGlutter, Sel.m('half'))} style={styles.self}>
                <DetailCard data={scope.left} />
                <DetailCard data={scope.right} />
            </div>
        )
    }
}

export default classToFComponent(GradeRowDetailViewClass)

type DetailCardProps = {
    data: GradeReacao | null
}

function DetailCard({ data }: DetailCardProps) {
    if (!_isObject(data) || !data.llt) {
        return <div className={Sel.colMd}>&nbsp;</div>
    }

    const hasGravidadeSim = data.statusGravidade === 2
    const hasGravidadeNao = data.statusGravidade === 3

    const hasConferenciaFB = data.statusConferencia === 2
    const hasConferenciaNV = data.statusConferencia === 3
    const hasConferenciaNB = data.statusConferencia === 4

    const hasObito = data.obtito
    const hasObitoOther = !hasObito

    //Sel.mt('base')
    return (
        <div className={clsx(Sel.brCard, Sel.colMd)} style={styles.mb0}>
            <div className={clsx(Sel.m('base'), Sel.dFlexV)}>
                <div className={clsx(Sel.dFlexH, Sel.flexGrow1)}>
                    <div className={clsx(Sel.textWeightMedium, Sel.textSm, Sel.textBreakAll)}>{data.nome}</div>
                    <div className={clsx(Sel.textXs, Sel.textGray500, Sel.fontMono, Sel.mt('half'))}>PT: {data.pt}</div>
                    <div className={clsx(Sel.textXs, Sel.textGray500, Sel.fontMono)}>LLT: {data.llt}</div>
                    {hasGravidadeSim && (
                        <div className={clsx(Sel.gradeGravidadeSim, Sel.mt('half'))}>
                            Gravidade:
                            {data.gravidadeCount}/{data.gravidadeCountMax}
                        </div>
                    )}
                    {hasGravidadeNao && (
                        <div className={clsx(Sel.gradeGravidadeNao, Sel.mt('half'))}>Gravidade: Não</div>
                    )}
                </div>
                <div className={clsx(Sel.dFlexH, Sel.alignContentCenter)}>
                    {hasConferenciaFB && (
                        <div className={Sel.gradeConferenciaForaBula}>
                            <img src={Icons.circleAlertIconUrl} width="16" height="16" />
                            <span>Fora da Bula</span>
                        </div>
                    )}
                    {hasConferenciaNV && (
                        <div className={Sel.gradeConferenciaNaoVerificado}>
                            <img src={Icons.eyeIconUrl} width="16" height="16" />
                            <span>Não verificado</span>
                        </div>
                    )}
                    {hasConferenciaNB && (
                        <div className={Sel.gradeConferenciaNaBula}>
                            <img src={Icons.bookOpenIconUrl} width="16" height="16" />
                            <span>Na Bula</span>
                        </div>
                    )}

                    <div className={Sel.flexGrow1}></div>
                    {hasObito && <div className={clsx(Sel.gradeDefechoMorte, Sel.textCenter)}>Morte</div>}
                    {hasObitoOther && <div>&nbsp;</div>}
                </div>
            </div>
        </div>
    )
}
